<template>
    <div class="param-box">
        <div class="param-box-content">
            <div class="param-item">
                <label class="label">文字内容</label>
                <div class="label-main">
                    <el-input v-model="control.text" size="small"></el-input>
                </div>
            </div>
        </div>
        <div class="param-box-content">
            <div class="param-item">
                <label  class="label">字体大小</label>
                <div class="label-main">
                    <el-input v-model="control.fontSize" size="small"></el-input>
                </div>
            </div>
        </div>
        <div class="param-box-content">
            <div class="param-item">
                <label  class="label">字体颜色</label>
                <div class="label-main">
                    <el-color-picker v-model="control.color" size="small"></el-color-picker>
                </div>
            </div>
        </div>
        <div class="param-box-content">
            <div class="param-item">
                <label  class="label">粗体</label>
                <div class="label-main">
                    <el-select v-model="control.bold" size="small">
                        <el-option label="正常" value="normal"></el-option>
                        <el-option label="加粗" value="bold"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"ThreeTextParams",
    props: {
        control: {
            type: Object,
            default: {
                text:'',
                fontSize:'',
                color:'',
                bold:''
            }
        }
    },
    watch: {
        control:{
            handler(newVal,oldVal){
                this.$emit("update:control",newVal);
            },
            deep:true
        }
    },
}
</script>

<style lang='less' scoped>
    .param-box{
        width: 100%;height:100%;
        .param-box-content{
            .param-item{
                margin-bottom: 5px;display:flex;align-items:center;
                .divider{
                    margin: 10px 0;
                }
                .label{
                    color: #030a1e;width: 80px;text-align: right;margin-right: 5px;
                }
                .label-main{
                    flex:1;overflow: hidden;color: #030a1e;
                }
            }
            .btn{
                margin: 0 auto;
            }
        }
    }
</style>